import { Button } from 'modules';
import React, { useRef } from 'react';
import toast from 'react-hot-toast';
import * as XLSX from 'xlsx';

type Props = {
  onReaderCallback?: (data: any) => void;
  classNames?: string;
};

const ExcelReader = (props: Props) => {
  const { onReaderCallback, classNames } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  const onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = (event.target.files as FileList)[0];

    const reader = new FileReader();

    reader.onabort = () => toast.error('Việc đọc tập tin đã bị hủy bỏ');

    reader.onerror = () => toast.error('Việc đọc tập tin không thành công');

    reader.onload = () => {
      const binaryStr = reader.result;

      const workbook = XLSX.read(binaryStr, { type: 'binary' });

      workbook.SheetNames.forEach((sheetName) => {
        let rowObject = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

        onReaderCallback?.(rowObject);
      });
    };

    reader.readAsBinaryString(file);
  };

  const onButtonClick = () => {
    inputRef?.current?.click?.();
  };

  return (
    <>
      <input ref={inputRef} type='file' hidden onChange={onFileChange} />
      <Button
        onClick={onButtonClick}
        label='Tải tệp lên'
        className={classNames}
      />
    </>
  );
};

export default ExcelReader;
